import { UiModuleOverviewConfiguration } from './ui-module-overview-configuration.model';

export interface SeahorseModule {
  id: number;
  organisationId: string;
  mappingKey: string;
  isActive: boolean;
  overviewConfigurationId?: number | null;
  overviewConfiguration?: UiModuleOverviewConfiguration | null;
}

export class SeahorseModule {
  static default(): SeahorseModule {
    return {
      id: 0,
      organisationId: null,
      mappingKey: null,
      isActive: true,
      overviewConfigurationId: null,
      overviewConfiguration: null,
    };
  }
}
